export default {
  copy_load_error: 'Please try again.',
  copy_id_error: 'No job ID found.',
  component: 'o-job-detail',
}
